import React, { Fragment, useEffect, useState } from "react";

export default function TypeWriterText({
                                           text = "",
                                           speed = 10,
                                           enableTyping = false,
                                           onComplete
                                       }) {
    const [displayedText, setDisplayedText] = useState("");

    useEffect(() => {
        const fullText = String(text);

        if (!enableTyping) {
            setDisplayedText(fullText);
            if (onComplete) onComplete();
            return;
        }

        setDisplayedText("");

        if (fullText.length === 0) {
            if (onComplete) onComplete();
            return;
        }

        let i = 0;
        let cancelled = false;
        let timerId = null;

        const tick = () => {
            if (cancelled) return;

            setDisplayedText((prev) => prev + fullText.charAt(i));
            i++;

            if (i >= fullText.length) {
                if (onComplete) onComplete();
                return;
            }

            timerId = setTimeout(tick, speed);
        };

        timerId = setTimeout(tick, speed);

        return () => {
            cancelled = true;
            if (timerId) clearTimeout(timerId);
        };
    }, [text, speed, enableTyping, onComplete]);

    return (
        <Fragment>
            {displayedText}
            {enableTyping && <span className="cursor ms-1 mb-2">▍</span>}
        </Fragment>
    );
}
